import React from 'react';
import Card from '../../../reusableComponents/cards/Card1';

const PerformanceCard = () => {
  // Card data with content only (backgrounds will be hardcoded)
  const cardData = [
    {
      title: "N/A",
      description: "Total classes attended"
    },
    {
      title: "N/A",
      description: "On time submission"
    },
    {
      title: "N/A",
      description: "Total average results"
    },
    {
      title: "N/A",
      description: "On time fees payment"
    }
  ];

  return (
    <div className="w-full max-w-full flex flex-col">
      {/* Title with reduced line height and spacing */}
      <div className="text-neutral-900 text-xl font-bold font-['Arial'] capitalize leading-tight mb-4">
        Your performance
      </div>
      
      {/* Card grid with reduced spacing */}
      <div className="flex flex-col gap-4 w-full">
        {/* First row */}
        <div className="flex flex-col md:flex-row justify-start items-stretch gap-6 w-full">
          <Card
            title={cardData[0].title}
            description={cardData[0].description}
            showIcon={false}
            showLabels={false}
            className="flex-1 bg-[#FEF0E5]"
            width="auto"
          />

          <Card
            title={cardData[1].title}
            description={cardData[1].description}
            showIcon={false}
            showLabels={false}
            className="flex-1 bg-[#EBEEFF]"
            width="auto"
          />
        </div>

        {/* Second row */}
        <div className="flex flex-col md:flex-row justify-start items-stretch gap-6 w-full">
          <Card
            title={cardData[2].title}
            description={cardData[2].description}
            showIcon={false}
            showLabels={false}
            className="flex-1 bg-[#E5F6F2]"
            width="auto"
          />

          <Card
            title={cardData[3].title}
            description={cardData[3].description}
            showIcon={false}
            showLabels={false}
            className="flex-1 bg-[#FFEDF7]"
            width="auto"
          />
        </div>
      </div>
    </div>
  );
};

export default PerformanceCard;